import {
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  Dialog as MuiDialog,
} from "@mui/material";

import PrimaryButton from "../PrimaryButton";

import { styled } from "@mui/system";

// import Container from "../Container";

const StyledDialog = styled(MuiDialog)`
  & .MuiPaper-root {
    border: 12px solid ${(props) => props.theme.palette.background.paper};
    border-radius: ${(props) => props.theme.shape.borderRadius}px;
    background-color: ${(props) => props.theme.palette.background.default};
    background-image: none;
    height: 15rem;
    width: 20rem;
  }
`;

const StyledDialogTitle = styled(DialogTitle)`
  font-weight: bold;
`;

const StyledDialogContent = styled(DialogContent)`
  display: flex;
  justify-content: center;
  align-items: center;
`;

const Dialog = ({
  title,
  openButtonLabel = "Open Dialog",
  showOk = true,
  showCancel = false,
  action = () => {},
  children,
  showButton,
  primaryButtonText = "OK",
  onClose,
  ...props
}) => {
  return (
    <>
      <StyledDialog
        maxWidth="sm"
        // fullWidth="sm"
        scroll="paper"
        // open={open}
        {...props}
      >
        {title && <StyledDialogTitle variant="h4">{title}</StyledDialogTitle>}
        <StyledDialogContent>{children}</StyledDialogContent>
        <DialogActions>
          <Grid container justifyContent="space-around">
            {showCancel && (
              <PrimaryButton onClick={onClose} sx={{ m: 3 }}>
                Cancel
              </PrimaryButton>
            )}
            {showOk && (
              <PrimaryButton
                onClick={() => {
                  action();
                  // setOpen(false);
                }}
                sx={{ m: 3 }}
              >
                {primaryButtonText}
              </PrimaryButton>
            )}
          </Grid>
        </DialogActions>
      </StyledDialog>
    </>
  );
};

export default Dialog;
